import React, { memo } from "react";
import PropTypes from "prop-types";
import { isBeforePullinTime } from "../../../../utils/isBeforePullInTime";
import { navigateToCell } from "./shared.js";

export const RenderEarlyPullInCheckbox = memo(({ row, rowCount, column, onCellInputBlur }) => {
  const { original, index } = row;
  const { id } = column;
  const { pulloutStatus, scheduledPullinTimeFmt, earlyPullIn } = original;
  const disabledStatuses = ["PENDING", "RESET"];
  const checkedStatuses = ["OUT-OF-SERVICE"];
  let earlyPullInCheckboxDisabled = true;

  // Determine if the checkbox should be disabled
  if (!disabledStatuses.includes(pulloutStatus)) {
    const earlyPullInIsValid = isBeforePullinTime(scheduledPullinTimeFmt);
    earlyPullInCheckboxDisabled = !earlyPullInIsValid;
  }

  // Determine the checked value
  const isChecked =
    earlyPullIn !== undefined
      ? earlyPullIn === "Y"
      : checkedStatuses.includes(pulloutStatus) && !earlyPullInCheckboxDisabled;

  return (
    <input
      type="checkbox"
      id={`${id}-${index}`}
      name="earlyPullInCheckbox"
      checked={isChecked}
      onChange={(e) => {
        onCellInputBlur(e.currentTarget.checked, index, id);
      }}
      onKeyDown={(e) => {
        if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
          e.preventDefault();
          navigateToCell(id, index, e.key, rowCount);
        }
      }}
      disabled={earlyPullInCheckboxDisabled}
      style={{ marginRight: "5px" }}
    />
  );
});

RenderEarlyPullInCheckbox.displayName = "RenderEarlyPullInCheckbox";

RenderEarlyPullInCheckbox.propTypes = {
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
    original: PropTypes.shape({
      pulloutStatus: PropTypes.string,
      scheduledPullinTimeFmt: PropTypes.string,
      earlyPullIn: PropTypes.string,
    }).isRequired,
  }).isRequired,
  rowCount: PropTypes.number.isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCellInputBlur: PropTypes.func.isRequired,
};
